import { Dispatch, SetStateAction, useRef } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useTranslation } from 'react-i18next';
import { useAppStoreDispatch, useAppStoreSelector } from '../../../store';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { logout } from '../../auth/store/userSlice';
import UserSettings from '../../auth/components/UserSettings';
import Drawer from '../components/Drawer';
import { useHideNavbar } from './AppBar.hook';
import axios from '../../../utils/api/axiosInstance';
import {
  fetchGuestPortalsThunk,
  fetchPortalsThunk,
  removePortals,
  selectIsGuestMode,
  selectSelectedPortal,
} from '../../portal/store';
import { fetchSettingsThunk } from '../../settings/store';
import User from '../../auth/models/user';
import logo_not_found from '../../../assets/no_logo_found.png';
import { useToast } from '../../general/components/Toast.hook';
import { toggleDrawer } from '../store';
import { fetchCategoriesThunk } from '../../category/store';
import { AxiosError } from 'axios';
import ImageFallback from '../../general/components/ImageFallback';
import { useColorMode } from '../../../theme/ColorModeContext';
// import Dropdown from './Dropdown';

export default function AppNavBar({
  setAppLoading,
}: {
  setAppLoading: Dispatch<SetStateAction<boolean>>;
}) {
  const [isModalShow, setIsModalShow] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [isUpdateDatabaseLoading, setIsUpdateDatabaseLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navBarRef = useRef<HTMLElement>(null);
  const drawerRef = useRef<HTMLDivElement>(null);
  // const [isHamburgerActive, setIsHamburgerActive] = useState(false);
  const dispatch = useAppStoreDispatch();
  const navigate = useNavigate();
  const userState = useAppStoreSelector((state) => state.user);
  const selectedPortal = useAppStoreSelector(selectSelectedPortal);
  // const portalState = useAppStoreSelector(state => state.portal)
  // const isHamburgerActive = useAppStoreSelector(
  //   (state) => state.app.data.modals.drawer.isDrawerOpen
  // );
  const postSettingsState = useAppStoreSelector((state) => state.settings.data);
  const location = useLocation();
  const token = User.loadUserToken();
  const isGuest = useAppStoreSelector(selectIsGuestMode);
  const { t } = useTranslation();
  const [triggerMessage] = useToast();
  const open = Boolean(anchorEl);
  const { mode, toggleMode } = useColorMode();

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const onLogoutClickHandler = () => {
    handleMenuClose();
    dispatch(logout());
    dispatch(removePortals());
    navigate('/auth');
  };
  useHideNavbar(navBarRef, drawerRef, postSettingsState?.sizes.navbar, () => {
    dispatch(toggleDrawer(false));
  });

  // useEffect(() => {
  //     console.log('Location: ', location, location.pathname.includes('/portal/'));
  // }, [location]);

  const onUpdateDatabaseHandler = async () => {
    handleMenuClose();
    try {
      setIsUpdateDatabaseLoading(true);
      setAppLoading(true);
      await axios.post('/api/admin/reconfigure', {});
      await dispatch(fetchPortalsThunk()).unwrap();
      await dispatch(fetchGuestPortalsThunk()).unwrap();
      await dispatch(fetchSettingsThunk()).unwrap();
      await dispatch(fetchCategoriesThunk()).unwrap();
    } catch (error) {
      console.log(error);
      if ((error as AxiosError).message) {
        triggerMessage((error as AxiosError).message, true);
      } else {
        triggerMessage(
          'Something went wrong with the update of the data!',
          true
        );
      }
    } finally {
      setIsUpdateDatabaseLoading(false);
      setAppLoading(false);
    }
  };


  const computeUpdateDatabaseElement = () => {
    //get role from userState
    if (userState.data.user?.isSuperuser || userState.data.user?.permissions?.includes('syncData')) {
      if (isUpdateDatabaseLoading) {
        return (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Updating...
          </MenuItem>
        );
      } else {
        return (
          <MenuItem onClick={onUpdateDatabaseHandler}>
            Update Data
          </MenuItem>
        );
      }
    }
    return null;
  };

  /* const computeNavBarSelectedHeight = () => {
    // const heightNumber = postSettingsState?.sizes.navbar.heigth
    const heightNumber = postSettingsState?.sizes.navbar
      .match(/([\d\.]+)(.*)/)
      ?.filter((num) => +num)
      .join();
    // console.log(heightNumber);
    return heightNumber && +heightNumber >= 3.5
      ? `${+heightNumber}rem`
      : '3.5rem';
  }; */

  const showModal = () => {
    // console.log(resetPassword)
    if (userState.data.user?.password_reset !== undefined && resetPassword === false) {
      return isModalShow || userState.data.user.password_reset;
    } else {
      return isModalShow
    }
  }

  return (
    <Box>
      <UserSettings
        isModalShow={showModal()}
        setIsModalShow={setIsModalShow}
        setResetPassword={setResetPassword}
        resetPassword={userState.data.user?.password_reset}
      />
      <AppBar
        position="sticky"
        color="inherit"
        sx={{
          alignItems: 'center',
        }}
        ref={navBarRef}
      >
        <Toolbar
          sx={{
            p: 0,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box>
            <Drawer
              drawerRef={drawerRef}
            /* navBarHeight={computeNavBarSelectedHeight()} */
            />
          </Box>

          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Link
              to="/"
              style={{
                height: '100%',
                padding: '.3rem',
                textAlign: 'center',
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
              }}
              onClick={() => dispatch(toggleDrawer(false))}
            >
              <Box
                sx={{
                  padding: 0,
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {postSettingsState?.logo ? (
                  <ImageFallback
                    image={postSettingsState.logo}
                    style={{ height: '100%' }}
                    alt="Portal Station Logo"
                  />
                ) : (
                  <img
                    src={logo_not_found}
                    style={{ height: '40%' }}
                    alt="not found"
                  />
                )}
                {selectedPortal && (
                  <Box
                    sx={{
                      ml: 1
                    }}
                  >
                    {selectedPortal?.portalWidgetHeadline}
                  </Box>
                )}
              </Box>
            </Link>
          </Box>

          <Box
            sx={{
              flexGrow: 1
            }}
          />

          <IconButton
            onClick={toggleMode}
            className="ps"
            sx={{
              mr: 1,
              width: 40,
              height: 40,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            title={mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          >
            {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
          </IconButton>

          <IconButton
            onClick={handleMenuOpen}
            className="ps"
            sx={{
              visibility: location.pathname.includes('/portal/')
                ? 'hidden'
                : 'visible',
              width: 40,
              height: 40,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 0,
            }}
          >
            <AccountCircleIcon />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            {!location.pathname.includes('/portal/') && (
              <>
                {computeUpdateDatabaseElement()}
                {(userState.data.user?.isSuperuser || userState.data.user?.permissions?.includes('syncData')) && (
                  <Divider className="ps" />
                )}
                <MenuItem
                  onClick={() => { handleMenuClose(); setIsModalShow(true); }}>
                  {t('app.settings')}
                </MenuItem>

                {/* <MenuItem onClick={() => navigate('/mdm-config')}>
                  {t('app.mdmConfig')}
                </MenuItem>

                <Divider className="ps" />

                <MenuItem onClick={() => navigate('/logs')}>
                  {t('logsview.logsview')}
                </MenuItem> */}

                <Divider className="ps" />

                {token && (
                  <MenuItem onClick={onLogoutClickHandler}>
                    {t('app.logout')}
                  </MenuItem>
                )}
                {!token && isGuest && (
                  <MenuItem onClick={() => { handleMenuClose(); navigate('/auth'); }}>
                    {t('auth.signIn')}
                  </MenuItem>
                )}
              </>
            )}
          </Menu>
        </Toolbar>
      </AppBar>
      {/* {selectedPortal?.portalName && ( */}
      {/*   <div */}
      {/*     style={{ */}
      {/*       width: '100%', */}
      {/*       // backgroundColor: 'red', */}
      {/*       zIndex: 1, */}
      {/*       position: 'fixed', */}
      {/*       top: postSettingsState?.sizes.navbar, */}
      {/*       // marginTop: postSettingsState?.sizes.navbar, */}
      {/*     }} */}
      {/*     ref={titleRef} */}
      {/*   > */}
      {/*     <div */}
      {/*       style={{ */}
      {/*         width: '20rem', */}
      {/*         backgroundColor: 'black', */}
      {/*         border: 'solid black 1px', */}
      {/*         margin: '0 auto', */}
      {/*         clipPath: 'polygon(0 0, 100% 0, 100% 0, 90% 100%, 10% 100%, 0 0)', */}
      {/*       }} */}
      {/*     > */}
      {/*       <div */}
      {/*         style={{ */}
      {/*           width: 'calc(20rem - 2px)', */}
      {/*           backgroundColor: 'white', */}
      {/*           margin: '0 auto', */}
      {/*           clipPath: */}
      {/*             'polygon(0 0, 100% 0, calc(100% - 1px) 0, 90% 100%, 10% 100%, 1px 0)', */}
      {/*           textAlign: 'center', */}
      {/*         }} */}
      {/*       > */}
      {/*         {selectedPortal.portalName} */}
      {/*       </div> */}
      {/*     </div> */}
      {/*   </div> */}
      {/* )} */}
    </Box>
  );
}
